module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/broccoli-1d47201e.webp";